export default __webpack_public_path__ + "static/media/plan-dots2.45ba8e6a.svg";